/**
 * "Help with this step" links to InventiveHQ products/services.
 * RULES (see docs/PLAN-breach-companion.md §6): max 2 per step, specific product or store
 * pages (never the homepage), the guide must be complete without them, always labelled.
 * Intentionally EMPTY until the InventiveHQ product/URL map is supplied — do not invent URLs.
 */
export interface HelpLink { label: string; blurb: string; url: string }
export const HELP_LINKS: Record<string, HelpLink[]> = {
  // start: [], triage: [], contain: [], investigate: [], eradicate: [], notify: [], recover: [], learn: [],
}

/**
 * "Call us" route, shown on every step. TODO(owner): set `phone` to the InventiveHQ
 * incident line once provided; until then people are sent to the contact page.
 */
export const CALL_US: { label: string; phone: string | null; href: string } = {
  label: "Talk to an InventiveHQ responder",
  phone: null,
  href: "/contact",
}
export const TALK_TO_SOMEONE = { label: CALL_US.label, url: CALL_US.href }
